<template>
  <section>
    <div
      class="section-content with-shadow"
      style="margin-top: 19px; height:93.5%"
    >
      <h2 style="margin:0">Il tuo abbonamento</h2>
      <div class="flex flex-column justify-content-between">
        <div class="flex justify-content-start w-75 my-3">
          <img
            style="width: 20%"
            src="https://api.quomi.it/oldimg/ICONA_2-%281%29.png"
            alt="calendar-logo"
          />
          <div class="flex justify-content-center align-items-center pl-5">
            <span class="text-bold pr-5">STATO:</span>
            <span
              class="text-primary-color text-big text-bold"
              v-html="isRecurringActive ? 'ATTIVO' : 'DISATTIVO'"
            />
          </div>
        </div>

        <div class="py-5">
          <b class="qbg-primary rounded pa-1 d-block" style="width: fit-content">
            <i class="fa fa-truck pr-2"></i>
            <span
              v-html="
                isRecurringActive
                  ? `Ottimo! Hai la consegna gratuita su tutti gli ordini`
                  : `Attiva l'abbonamento per ottenere la consegna gratuita! `
              "
            ></span>
          </b>
        </div>

        <home-calendar :value="recurring" :shipmentZone="shipmentZone" v-if="shipmentZone && isRecurringActive"/>

        <CTA
          content="Vai a gestione abbonamento"
          @click="goToSubscription()"
          class="align-self-start"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { deliveryContainer } from '../../mixins/deliveryContainer';
import HomeCalendar from "./HomeCalendar";
import { RecurringHelper } from '../../services/RecurringHelper'

export default {
  components: {
    HomeCalendar,
  },
  mixins: [
    deliveryContainer
  ],
  data() {
    return {
      shipmentZone: null,
      min: null,
    }
  },
  computed: {
    user() {
      return this.$root.user;
    },
    recurring() {
      return this.user.recurring
    },
    isRecurringActive() {
      return this.recurring && this.recurring.enabled && this.min
    },
  },
  methods: {
    goToSubscription() {
      this.$router.push({ name: "profile_subscription" });
    },
    loadShipmentZone() {
      return this.$_deliveryContainer_loadSubscriptionDelivery().then(response => {
          try {
            this.shipmentZone = response.body.included.find(record => record.type === 'shipment-zone')
          } catch (e) {
            console.log(e)
          }
        })
    }
  },
  mounted() {
    this.loadShipmentZone()
    new RecurringHelper().loadAndCheckMin(this.recurring).then(i => {
      this.min = i;
    })
  }
};
</script>

<style scoped>
@media(min-width: 769px) and (max-width: 1024px) {
  .with-shadow {
    margin-top: 0 !important;
    height: 99.5% !important;
    margin-left: 15px;
  }
}
</style>
